/*!
 *
 *  menu.ts
 *
 */
import { overlay } from './overlay';
import waitTransition from './waitTransition';
class menu {
    button;
    label;
    menu;
    container;
    shouldHide;
    isAnimating = false;
    links;
    transitionCancel;
    isScrollLocked = false;
    header;
    constructor(options) {
        this.button = document.querySelector(options.button);
        this.label = document.querySelector('.site-menu-toggle__label');
        this.menu = document.querySelector(options.menu);
        this.container = this.menu.children[0];
        this.links = this.menu.querySelectorAll('a[href], button[data-href]');
        this.shouldHide = options.shouldHide || ['phone', 'tablet'];
        this.header = document.getElementById('header');
        this.init();
        this.menu.classList.add('-ready');
        this.button.addEventListener('click', () => {
            if (this.isAnimating)
                return;
            if (this.menu.hidden) {
                this.open();
            }
            else {
                this.close();
            }
        });
        window.addEventListener('resize', () => {
            this.init();
            overlay.reset();
        });
        document.addEventListener('click', (e) => {
            const target = e.target;
            const inside = this.container.contains(target) || this.button.contains(target);
            if (!(inside) && (this.shouldHide.includes(util.viewport) || this.header.classList.contains('-slim'))) {
                if (!this.menu.hidden) {
                    this.close();
                }
            }
            ;
        });
        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape')
                return;
            if (!this.shouldHide.includes(util.viewport) && !this.header.classList.contains('-slim'))
                return;
            if (this.menu.hidden)
                return;
            this.close();
            this.button.focus();
        });
        this.links.forEach((link) => {
            link.addEventListener('click', () => {
                console.log('link clicked');
                if (!this.shouldHide.includes(util.viewport) && !this.header.classList.contains('-slim'))
                    return;
                if (this.isSamePageHashLink(link)) {
                    this.close();
                }
            });
        });
    }
    open() {
        this.transitionCancel?.();
        this.isAnimating = true;
        overlay.open('sitemenu');
        this.button.setAttribute('aria-expanded', 'true');
        this.button.setAttribute('aria-label', 'サイトメニューを閉じる');
        this.label.textContent = 'Close';
        this.menu.hidden = false;
        this.menu.removeAttribute('inert');
        this.lockScroll();
        requestAnimationFrame(() => {
            this.transitionCancel = waitTransition(this.menu, 'visibility', () => {
                this.isAnimating = false;
            });
            this.menu.classList.add('-visible');
        });
    }
    close() {
        this.transitionCancel?.();
        this.isAnimating = true;
        overlay.close('sitemenu');
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-label', 'サイトメニューを開く');
        this.label.textContent = 'Open';
        this.transitionCancel = waitTransition(this.menu, 'visibility', () => {
            this.menu.hidden = true;
            this.isAnimating = false;
        });
        this.menu.classList.remove('-visible');
        this.menu.setAttribute('inert', '');
        this.unlockScroll();
    }
    scrollControll = (e) => {
        const isMenuOpen = this.menu.classList.contains('-visible');
        const inner = e.target.closest('.site-menu__container');
        if (isMenuOpen) {
            if (inner) {
                if (inner.scrollHeight > inner.clientHeight) {
                    e.stopPropagation();
                }
                else {
                    e.preventDefault();
                }
            }
            else {
                e.preventDefault();
            }
            ;
        }
        ;
    };
    lockScroll() {
        if (this.isScrollLocked)
            return;
        this.isScrollLocked = true;
        const html = document.documentElement;
        html.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.addEventListener('touchmove', this.scrollControll, { passive: false });
    }
    unlockScroll() {
        if (!this.isScrollLocked)
            return;
        this.isScrollLocked = false;
        const html = document.documentElement;
        html.style.overflow = 'auto';
        document.body.style.overflow = '';
        document.removeEventListener('touchmove', this.scrollControll);
    }
    isSamePageHashLink(a) {
        const href = a instanceof HTMLAnchorElement ? a.getAttribute('href') ?? '' : a.dataset.href ?? '';
        if (!href.includes('#'))
            return false;
        const url = new URL(href, location.href);
        const sameDoc = url.origin === location.origin &&
            url.pathname === location.pathname &&
            url.search === location.search;
        const hasHashTarget = url.hash.length > 1;
        return sameDoc && hasHashTarget;
    }
    init() {
        const shouldHide = this.shouldHide.includes(util.viewport) || this.header.classList.contains('-slim');
        this.menu.classList.add('-initializing');
        this.button.classList.add('-initializing');
        requestAnimationFrame(() => {
            if (shouldHide) {
                this.menu.setAttribute('inert', '');
                this.menu.hidden = true;
                this.menu.classList.remove('-visible');
                this.button.setAttribute('aria-expanded', 'false');
            }
            else {
                this.menu.removeAttribute('inert');
                this.menu.hidden = false;
                this.menu.classList.add('-visible');
                this.button.setAttribute('aria-expanded', 'true');
            }
            this.unlockScroll?.();
            this.button.setAttribute('aria-label', shouldHide ? 'サイトメニューを開く' : 'サイトメニューを閉じる');
            requestAnimationFrame(() => {
                this.menu.classList.remove('-initializing');
                this.button.classList.remove('-initializing');
            });
        });
    }
}
export default menu;
